// extracted by mini-css-extract-plugin
export default {"referralComponent":"pU","greyBack":"qU","greenBack":"rU","greenText":"sU","explainText":"tU","spinner":"uU","storedText":"vU"};
    if(module.hot) {
      // 1715188238894
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  